<script lang="ts" setup>
import IconAndText from '../../../Poker/Overlays/IconAndText.vue'

export interface HandDetailErrorProps {
  handId: string
}
defineProps<HandDetailErrorProps>()
</script>
<template>
  <IconAndText
    icon="mdi-alert-circle-outline"
    class="pa-8"
    style="--icon-size: 5rem; --icon-color: var(--clr-error)"
    :title="$t('messages.oops_error')"
    :subtitle="$t('messages.opps_error_sub')"
  >
    <div
      v-if="handId"
      class="clr-grey text-small mt-4"
    >
      Hand id:
      <div>
        {{ handId }}
      </div>
    </div>
  </IconAndText>
</template>
